import { Component,EventEmitter,Output, OnInit,ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalMessageService, RoutingService, TranslationService, GlobalMessageType, UrlPipe } from '@spartacus/core';
import { CustomFormValidators, FormErrorsComponent } from '@spartacus/storefront';
import { ToastrService } from 'ngx-toastr';
import{CustomInventoryLoginService} from 'src/app/modules/custom-login/custom-inventory-login/custom-inventory-login.service';
import { CustomProductsService } from '../../custom-landing/custom-products/custom-products.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Router, RouterLink } from '@angular/router';
import { InventoryBreadcrumbComponent } from '../../../shared/components/inventory-breadcrumb/inventory-breadcrumb.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-custom-inventory-update-password',
    templateUrl: './custom-inventory-update-password.component.html',
    styleUrls: ['./custom-inventory-update-password.component.scss'],
    imports: [RouterLink, InventoryBreadcrumbComponent, FormsModule, ReactiveFormsModule, NgIf, FormErrorsComponent, UrlPipe]
})
export class CustomInventoryUpdatePasswordComponent implements OnInit {
  title: any;
  navigationData: any;
  updateForm: UntypedFormGroup;
  error: any;
  showError = false;
  @Output()
  submitted = new EventEmitter<{ oldPassword: string; newPassword: string }>();

  constructor(private fb: UntypedFormBuilder, private translation: TranslationService, private routingService: RoutingService,
    private customInventoryLoginService: CustomInventoryLoginService, private userAccountFacade: UserAccountFacade,
    private cd: ChangeDetectorRef, private customProductService: CustomProductsService,private router: Router,
    private toastService: ToastrService, protected  globalMessageService: GlobalMessageService) { }

  ngOnInit(): void {
     this.translation.translate('breadcrumb.updatePassword.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.updatePassword.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.updateForm = this.fb.group(
      {
        username:['', [Validators.required]],
        // oldPassword: [null, [Validators.required]],
        newPassword: ['', [Validators.required, Validators.pattern(/.{8}/)]],
        newPasswordConfirm: ['', [Validators.required]],
      },
      {
        validators: CustomFormValidators.passwordsMustMatch(
          'newPassword',
          'newPasswordConfirm'
        ),
      }
    );
  }
  onSubmit(): void {
    const { username } = this.updateForm.controls;
    const { newPassword } = this.updateForm.controls;
    const { newPasswordConfirm } = this.updateForm.controls;
  
    this.customInventoryLoginService.inventoryUpdatePassword(username.value,newPassword.value, newPasswordConfirm.value).subscribe(
      data => {
        if (data && data === 'SUCCESS'){
          if (data === 'SUCCESS'){
            this.toastService.show("Password updated successfully");
            setTimeout(()=>{
              this.router.navigate(['inventory/inventorylogin']);
            },2000)
            
          }else {
           this.showError = true;
          this.globalMessageService.add(data.error, GlobalMessageType.MSG_TYPE_ERROR);
          }
        }else{
          this.toastService.show("Something went wrong, please try again");
          // if (data === 'success') {
          //   this.router.navigate(['inventory/inventorylogin']);
          // }else{
          //   this.toastService.show(this.error);
          // }
        }
      },
      (err: any)=>{
        console.log(err);
        this.toastService.show(err.error.errors[0].message)
      }
    );
    if (this.updateForm.valid) {
      this.submitted.emit({
        oldPassword: this.updateForm.value.oldPassword,
        newPassword: this.updateForm.value.newPassword,
      });
    } else {
      this.updateForm.markAllAsTouched();
    }

  }

  backToLogin(): void{
    this.router.navigate(['inventory/inventorylogin']);
  }

}
